import React from 'react';
import {Text} from '@wix/wix-ui-tpa';
import {classes} from './ShippingSectionOverride.st.css';

export interface ShippingSectionTextProps {
  dataHook: string;
  text?: string | null;
  isTitle?: boolean;
  /**
   * Renders the value in an LTR bidi isolate. A phone is a left-to-right entity, so without this its leading
   * `+` resolves against an RTL page and renders detached at the far end of the number.
   * @see https://github.com/wix-private/ecom-platform-storefront/blob/master/packages/ecom-platform-checkout/src/components/Checkout/ContactAndAddressSummary/ContactAndAddressSummary.tsx
   */
  isLtrIsolated?: boolean;
}

export const ShippingSectionText: React.FC<ShippingSectionTextProps> = ({
  dataHook,
  text,
  isTitle = false,
  isLtrIsolated = false,
}) => {
  const textClassName = isTitle ? classes.title : classes.text;

  return (
    <div className={isTitle ? classes.wrapper : ''}>
      <Text className={textClassName} data-hook={dataHook}>
        {isLtrIsolated ? <bdi dir="ltr">{text}</bdi> : text}
      </Text>
    </div>
  );
};
